//预习任务
export const SCHOOL_OVERVIEW = 'school_overview';
export const COURSEWARE_RESOURCE = 'courseware_resource';
export const ACTIVITY_PROPORTOPN = 'activity_proportopn';
export const ATTENDANCE = 'attendance'
export const ACHIEVEMENT_ANALYSIS = 'achievement_analysis'
export const DEPARTMENT_RESOURCE = 'department_resource'
export const DEPARTMENT_RESOURCE_DETAILS = 'department_resource_details'



// WEBPACK FOOTER //
// ./src/store/situation/type.js